import { Subject, Subscription } from 'rxjs';

import { Facade } from '@bolteu/lattice';

import { ProviderPortalModuleSetup } from '../Module';
import { ObservableAndState } from '../utils/observable_and_state';

export type NavigationCall = {
  type: 'navigateTo' | 'replaceWith' | 'goBack';
  url?: string;
};

export type LocationChange = {
  pathname: string;
  search: string;
  hash: string;
};

// This is a wrapper around the Lattice Navigation Service
// used to adapt the navigation changes to the app level redux navigation module
export class ProviderPortalNavigationService {
  constructor(
    private readonly latticeNavigationService: Facade.NavigationService,
    private readonly locationObservable: ObservableAndState<LocationChange>,
    private readonly navigationSubject: Subject<NavigationCall> = new Subject<NavigationCall>(),
  ) {}

  public createForModule(
    module: Pick<ProviderPortalModuleSetup, 'latticeNavigationService'>,
  ): ProviderPortalNavigationService {
    return new ProviderPortalNavigationService(
      module.latticeNavigationService,
      this.locationObservable,
      this.navigationSubject,
    );
  }

  public navigateTo(target: Facade.NavigationTarget) {
    // We won't call the source function here, because we want to control the navigation
    // this.latticeNavigationService.navigateTo(target, params);

    this.navigationSubject.next({
      type: 'navigateTo',
      url: this.latticeNavigationService.getLink(target),
    });
  }

  public replaceWith(target: Facade.NavigationTarget) {
    this.navigationSubject.next({
      type: 'replaceWith',
      url: this.latticeNavigationService.getLink(target),
    });
  }

  public goBack() {
    // We won't call the source function here, because we want to control the navigation
    // this.latticeNavigationService.goBack();

    this.navigationSubject.next({
      type: 'goBack',
    });
  }

  // Get a subscription to the navigation calls
  public onNavigationCall(callback: (navCall: NavigationCall) => void): Subscription {
    return this.navigationSubject.subscribe(callback);
  }
}
